import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/login',
    component: () => import("../views/Login.vue")
  },
  {
    path: '/null',   
    name: 'null',
    component: () => import("../views/null.vue") // 首页
  },
  {
    path: "/home",
    name: "home",
    component:  () => import("../views/Home.vue") // 学员报名
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue") // 登录
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/train",
    name: "train",
    component: () => import("../views/Train.vue") // 培训证明
  },
  {
    path: "/queryStudent",
    name: "queryStudent",
    // component: () => import("../views/QueryStudent.vue") // 学员报名查询
    component: () => import("../views/queryStudent/queryStudent.vue"), // 学员查询
  },
  {
    path: "/queryRecord",
    name: "queryRecord",
    component: () => import("../views/QueryRecord.vue") // 培训记录查询
  },
  {
    path: "/queryExam",
    name: "queryExam",
    component: () => import("../views/QueryExam.vue") // 培训记录查询
  },
  {
    path: "/queryPractice",
    name: "queryPractice",
    component: () => import("../views/QueryPractice.vue") // 练习记录查询
  },
  {
    path: "/queryCourse",
    name: "queryCourse",
    component: () => import("../views/QueryCourse.vue") // 课程查询
  },
  {
    path: "/trainAudit",
    name: "trainAudit",
    component: () => import("../views/trainAudit/trainAudit.vue") // 培训审核上报---培训审核
  },
  {
    path: "/trainAppear",
    name: "trainAppear",
    component: () => import("../views/trainAppear/trainAppear.vue") // 培训审核上报---培训上报
  },
  {
    path: "/queryOrder",
    name: "queryOrder",
    component: () => import("../views/QueryOrder.vue") // 订单查询
  },
  {
    path: "/totalResult",
    name: "totalResult",
    component: () => import("../views/TotalResult.vue") // 练习成绩统计
  },
  {
    path: "/totalTime",
    name: "totalTime",
    component: () => import("../views/TotalTime.vue") // 学习时长统计
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/Notice.vue") // 学习时长统计
  },
  {
    path: "/log",
    name: "log",
    component: () => import("../views/Log.vue") // 操作日志
  },
  {
    path: "/upload",
    name: "upload",
    component: () => import("../views/Upload.vue") // 上传logo
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});


// 判断该路由是否需要登录权限
// router.beforeEach((to, from, next) => {
//   let tokenId = sessionStorage.getItem("tokenId");
//   if (tokenId) {  // 获取当前的token是否存在
//     if (to.path != '/login') {
//       next();
//     } else {
//       next({
//         path: from.path
//       });
//     }
//   } else {
//     if (to.path == '/login') {
//       next()
//     } else {
//       next({
//         path: '/login',
//         // query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
//       })
//     }
//   }
// })

export default router;
